import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LArtDeVivreEnUzege from "./sections/LArtDeVivreEnUzege";
import Shareholderpullquote from "./sections/Shareholderpullquote";
import InstitutionalTrustBar from "./sections/InstitutionalTrustBar";
import OurCoreCompetencies from "./sections/OurCoreCompetencies";
import FragmentsOfADay from "./sections/FragmentsOfADay";
import The48HourJourney from "./sections/The48HourJourney";
import TheEditingTeam from "./sections/TheEditingTeam";
import VipInsiderAccess from "./sections/VipInsiderAccess";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <h1 className="sr-only">Blue Phoenix Ventures — M&A Advisory for Lower Middle Market Businesses</h1>
      <LArtDeVivreEnUzege />
      <Shareholderpullquote />
      <InstitutionalTrustBar />
      <OurCoreCompetencies />
      <FragmentsOfADay />
      <The48HourJourney />
      <TheEditingTeam />
      <VipInsiderAccess />
      <Footer />
    </div>;
}